import {Decimal} from 'decimal.js';

const CENT_DECIMAL_PLACES = 2;

export function roundToCents(value: number) {
  return new Decimal(value).toDecimalPlaces(CENT_DECIMAL_PLACES, Decimal.ROUND_HALF_UP).toNumber();
}
